import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  activityItem: {
    minHeight: pxToRem(42),
    padding: `${pxToRem(10)}`,
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    display: 'flex',
    selectors: {
      '&:hover': { background: 'none' },
    },
  },
  bold: {
    fontWeight: 'bold',
  },
  personaCoin: {
    flexShrink: pxToRem(0),
    borderRadius: pxToRem(15),
    padding: `${pxToRem(3)} ${pxToRem(12)} ${pxToRem(0)} ${pxToRem(12)}`,
    marginTop: pxToRem(-3),
    marginRight: pxToRem(7),
  },
  itemContent: {
    overflow: 'hidden',
    flexGrow: 1,
  },
  itemName: {
    marginTop: pxToRem(10),
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'baseline',
  },
  actionMessage: {
    fontWeight: 400,
  },
  fontWeightNormal: {
    fontWeight: 400,
  },
  itemIndex: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
  },
  date: {
    marginLeft: pxToRem(10),
    color: theme.palette.neutralSecondary,
    flexShrink: 0,
    marginTop: pxToRem(3),
  },
  details: {
    margin: 0,
    padding: 0,
    selectors: {
      li: {
        color: theme.palette.neutralDark,
        display: 'list-item',
        fontSize: pxToRem(12),
        listStyle: 'inside',
        position: 'relative',
      },
    },
  },
});
